var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inward"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(_vm._s(_vm.$t('consolidation.consoPacking')))])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('consolidation.packingType')) + ":"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "name": "carrier",
      "value": "bin"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "bin")
    },
    on: {
      "change": function($event) {
        _vm.carrierChange(1)
      },
      "__c": function($event) {
        _vm.type = "bin"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('consolidation.bin')) + " "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "name": "carrier",
      "value": "tote"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "tote")
    },
    on: {
      "change": function($event) {
        _vm.carrierChange(1)
      },
      "__c": function($event) {
        _vm.type = "tote"
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('consolidation.tote')) + " "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.type == 'bin') ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.binID')) + ":"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]) : _vm._e(), _vm._v(" "), (_vm.type == 'bin') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packingtypebin),
      expression: "packingtypebin"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Binid')
    },
    attrs: {
      "autocomplete": "off",
      "disabled": _vm.isLoading,
      "type": "text",
      "placeholder": _vm.$t('consolidation.binIdPlaceholder'),
      "name": "Binid",
      "id": "Binid"
    },
    domProps: {
      "value": (_vm.packingtypebin)
    },
    on: {
      "change": _vm.validateid,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.packingtypebin = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Binid')),
      expression: "errors.has('Binid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('consolidation.binFieldErr')) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.isfound && _vm.type == 'bin') ? _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "font-size": "25px",
      "color": "green"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isnotfound && _vm.type == 'bin') ? _c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "font-size": "25px",
      "color": "red"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'tote') ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.toteID')) + ":"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]) : _vm._e(), _vm._v(" "), (_vm.type == 'tote') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packingtypetote),
      expression: "packingtypetote"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Toteid')
    },
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": _vm.isLoading,
      "placeholder": _vm.$t('common.toteIdPlaceHolder'),
      "name": "Toteid",
      "id": "Toteid"
    },
    domProps: {
      "value": (_vm.packingtypetote)
    },
    on: {
      "change": _vm.validateid,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.packingtypetote = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Toteid')),
      expression: "errors.has('Toteid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('consolidation.toteFieldErr')) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.isfound && _vm.type == 'tote') ? _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "font-size": "25px",
      "color": "green"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isnotfound && _vm.type == 'tote') ? _c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "font-size": "25px",
      "color": "red"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.isfound) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.scanProductID')) + ":")])]) : _vm._e(), _vm._v(" "), (_vm.isfound) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productId),
      expression: "productId"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('productId')
    },
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": _vm.isLoading,
      "placeholder": _vm.$t('common.productIdPlaceHolder'),
      "name": "productId",
      "id": "productId"
    },
    domProps: {
      "value": (_vm.productId)
    },
    on: {
      "change": _vm.validateProduct,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productId = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isfoundproductId && _vm.productId) ? _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "font-size": "25px",
      "color": "green"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isnotfoundproductId && _vm.productId) ? _c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "font-size": "25px",
      "color": "red"
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.showQCButton && _vm.productId) ? _c('div', {
    staticClass: "form-group row"
  }, [(_vm.showQCButton && _vm.productId) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productImage')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.brand')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.size')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.color')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.mrp')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productCategory')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productDescription')))])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.productDetails.productimage,
      "width": "100px",
      "height": "120px"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.productDetails.productname))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.productDetails.brand))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.productDetails.size))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.productDetails.color))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.productDetails.mrp))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.productDetails.productcategory))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.productDetails.productdescription))])])])])]) : _vm._e(), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.showOrder) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.orderID')) + ":"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderId),
      expression: "orderId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('orderId')
    },
    attrs: {
      "type": "text",
      "disabled": "true",
      "placeholder": "",
      "name": "orderId",
      "id": "orderId"
    },
    domProps: {
      "value": (_vm.orderId)
    },
    on: {
      "change": function($event) {},
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderId = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.clientName && _vm.orderId) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.client')) + " :"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientName),
      expression: "clientName"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('clientName')
    },
    attrs: {
      "type": "text",
      "disabled": "true",
      "placeholder": "",
      "name": "clientName",
      "id": "clientName"
    },
    domProps: {
      "value": (_vm.clientName)
    },
    on: {
      "change": function($event) {},
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientName = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.showboxdetails) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.showboxdetails) ? _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "table table-bordered"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.totalSKU')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.totalQuantity')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.totalCancelled')))])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v(_vm._s(_vm.totalsku))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v(_vm._s(_vm.totalquantity))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.cancel))])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.showboxdetails) ? _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "table table-bordered"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.totalQCAcceptedQty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.totalQCRejectedQty')))])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v(_vm._s(_vm.qcacceptqty))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b', [_c('p', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.qcrejectqty))])])])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.orderId && _vm.showBox) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.boxId')) + ":"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boxId),
      expression: "boxId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxId')
    },
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "placeholder": _vm.$t('common.boxIDPlaceHolder'),
      "name": "boxId",
      "id": "boxId"
    },
    domProps: {
      "value": (_vm.boxId)
    },
    on: {
      "change": _vm.assignBoxIdToOrder,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.boxId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('boxId')),
      expression: "errors.has('boxId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('consolidation.boxIdErr')) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.boxMapped && _vm.showPackingComplete) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.volumetricWeight')) + " :-")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<b>L</b>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:1'),
      expression: "'min_value:1'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxl')
    },
    attrs: {
      "autocomplete": "off",
      "disabled": _vm.isLoading,
      "name": "boxl",
      "placeholder": _vm.$t('common.lengthPlaceholder'),
      "type": "number",
      "step": "0.01",
      "min": "0.1"
    },
    model: {
      value: (_vm.boxl),
      callback: function($$v) {
        _vm.boxl = $$v
      },
      expression: "boxl"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('boxl')),
      expression: "errors.has('boxl')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('consolidation.boxFieldErr')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<b>B</b>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:1'),
      expression: "'min_value:1'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxb')
    },
    attrs: {
      "autocomplete": "off",
      "disabled": _vm.isLoading,
      "name": "boxb",
      "placeholder": _vm.$t('common.breadthPlaceHolder'),
      "type": "number",
      "step": "0.01",
      "min": "0.1"
    },
    model: {
      value: (_vm.boxb),
      callback: function($$v) {
        _vm.boxb = $$v
      },
      expression: "boxb"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('boxb')),
      expression: "errors.has('boxb')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('consolidation.boxFieldErr')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<b>H</b>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:1'),
      expression: "'min_value:1'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxh')
    },
    attrs: {
      "autocomplete": "off",
      "disabled": _vm.isLoading,
      "name": "boxh",
      "placeholder": _vm.$t('common.heightPlaceHolder'),
      "type": "number",
      "step": "0.01",
      "min": "0.1"
    },
    model: {
      value: (_vm.boxh),
      callback: function($$v) {
        _vm.boxh = $$v
      },
      expression: "boxh"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('boxh')),
      expression: "errors.has('boxh')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('consolidation.boxFieldErr')))])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.boxMapped && _vm.showPackingComplete) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.boxWeight')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min_value: 0
      }),
      expression: "{required:true,min_value:0}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('boxweight')
    },
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": _vm.isLoading,
      "value": "0",
      "name": "boxweight",
      "id": "boxweight"
    },
    model: {
      value: (_vm.boxweight),
      callback: function($$v) {
        _vm.boxweight = $$v
      },
      expression: "boxweight"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('boxweight')),
      expression: "errors.has('boxweight')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('consolidation.boxWeightErr')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("\n                  "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.getweight
    }
  }, [_vm._v(_vm._s(_vm.$t('common.getWeightButton')))])])]) : _vm._e(), _vm._v(" "), (_vm.rejectCheck && _vm.showQCButton) ? _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-left": "-15px"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.rejectReasons')) + " :")])]) : _vm._e(), _vm._v(" "), (_vm.rejectCheck && _vm.showQCButton) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3 checkbox"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedNames),
      expression: "checkedNames"
    }],
    attrs: {
      "type": "checkbox",
      "id": "reason1",
      "value": "Size mismatched"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedNames) ? _vm._i(_vm.checkedNames, "Size mismatched") > -1 : (_vm.checkedNames)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checkedNames,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Size mismatched",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedNames = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkedNames = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedNames = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('span', {
    attrs: {
      "for": "Size mismatched"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.sizeMismatched')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 checkbox"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedNames),
      expression: "checkedNames"
    }],
    attrs: {
      "type": "checkbox",
      "id": "reason2",
      "value": "Color mismatched"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedNames) ? _vm._i(_vm.checkedNames, "Color mismatched") > -1 : (_vm.checkedNames)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checkedNames,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Color mismatched",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedNames = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkedNames = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedNames = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('span', {
    attrs: {
      "for": "Color mismatched"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.colorMismatched')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 checkbox"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedNames),
      expression: "checkedNames"
    }],
    attrs: {
      "type": "checkbox",
      "id": "reason3",
      "value": "MRP mismatched"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedNames) ? _vm._i(_vm.checkedNames, "MRP mismatched") > -1 : (_vm.checkedNames)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checkedNames,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "MRP mismatched",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedNames = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkedNames = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedNames = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('span', {
    attrs: {
      "for": "MRP mismatched"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.mrpMismatched')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 checkbox"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedNames),
      expression: "checkedNames"
    }],
    attrs: {
      "type": "checkbox",
      "id": "reason4",
      "value": "Other"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedNames) ? _vm._i(_vm.checkedNames, "Other") > -1 : (_vm.checkedNames)
    },
    on: {
      "click": _vm.checkOtherReason,
      "__c": function($event) {
        var $$a = _vm.checkedNames,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Other",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedNames = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkedNames = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedNames = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('span', {
    attrs: {
      "for": "Other"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.other')))])])], 1), _vm._v(" "), (_vm.isOtherReason) ? _c('div', {
    staticClass: "col-md-4 test"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otherreason),
      expression: "otherreason"
    }],
    staticClass: "effect-1",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": _vm.isLoading,
      "placeholder": _vm.$t('common.enterReasonPlaceHolder'),
      "name": "OtherReason"
    },
    domProps: {
      "value": (_vm.otherreason)
    },
    on: {
      "keyup": _vm.clearerror,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otherreason = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isOtherReason) ? _c('span', {
    staticClass: "focus-border"
  }) : _vm._e(), _vm._v(" "), (_vm.isCheckboxError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.Checkboxerrors))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.boxMapped && _vm.showQCButton && _vm.productId) ? _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "float": "right"
    }
  }, [(!_vm.rejectCheck) ? _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "type": "button",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.ProductDetails('accept')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.accept')))]) : _vm._e(), _vm._v("  \n                "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.ProductDetails('reject')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.reject')))])]) : _vm._e()]), _vm._v(" "), (_vm.showPackingComplete) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.awbNo')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbNo),
      expression: "awbNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('awbNo')
    },
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": _vm.isLoading,
      "placeholder": _vm.$t('consolidation.awbPlaceholder'),
      "readonly": _vm.shipmentFound == true,
      "name": "awbNo",
      "id": "awbNo"
    },
    domProps: {
      "value": (_vm.awbNo)
    },
    on: {
      "change": function($event) {},
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbNo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('awbNo')),
      expression: "errors.has('awbNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('consolidation.awbNoErr')) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.showPackingComplete) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.courierName')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.courierName),
      expression: "courierName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('courierName')
    },
    attrs: {
      "name": "courierName",
      "placeholder": _vm.$t('consolidation.courierPlaceholder'),
      "id": "courierName"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.courierName = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('consolidation.courierPlaceholder')))]), _vm._v(" "), _vm._l((_vm.salesChannel), function(courier_obj) {
    return _c('option', {
      domProps: {
        "value": courier_obj.courierid
      }
    }, [_vm._v(_vm._s(courier_obj.couriername))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('courierName')),
      expression: "errors.has('courierName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('consolidation.courierNameErr')))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showPackingComplete) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "id": "submitbtn",
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.validateData
    }
  }, [_vm._v(_vm._s(_vm.$t('common.packingCompleted')))]), _vm._v("  \n              ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "float": "right"
    }
  }, [((_vm.shipmentPrintNotAvailable == true || _vm.printInvoiceEnable == true) && !_vm.btnDisable) ? _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "type": "button",
      "id": "invoicebutton",
      "size": "sm",
      "variant": "success",
      "disabled": _vm.btnDisable
    },
    on: {
      "click": _vm.PrintInvoiceAgaintsClient
    }
  }, [_vm._v(_vm._s(_vm.$t('common.printInvoice')) + "\n                ")]) : _vm._e(), _vm._v("   \n                "), (_vm.shipmentPrintNotAvailable == true || _vm.printLabelEnable == true) ? _c('button', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading,
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.PrintLabelAgaintsClient
    }
  }, [_vm._v(_vm._s(_vm.$t('common.printLabel')) + "\n                ")]) : _vm._e(), _vm._v(" \n                "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading,
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.carrierChange(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.resetBtn')))]), _vm._v(" \n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.isfound && _vm.productsPendingData.length) ? _c('b-button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading,
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.Showtable(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('consolidation.showProduct')))]) : _vm._e()], 1)])])]), _vm._v(" "), (_vm.isfoundDataPendingProduct) ? _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right"
    }
  }, [_c('b-button', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "variant": "warning"
    },
    on: {
      "click": _vm.closeTable
    }
  }, [_vm._v(_vm._s(_vm.$t('consolidation.closeList')))])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.productsPendingData.length) ? _c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', {
    staticClass: "theader"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [(_vm.type == 'bin') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.binID')))])]) : _vm._e(), _vm._v(" "), (_vm.type == 'tote') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.toteID')))])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.orderID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.eanCode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('consolidation.productScanned')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('consolidation.qcStatus')))])])])]), _vm._v(" "), _c('tbody', [(!_vm.productsPendingData.length) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.productsPendingData), function(data, index) {
    return _c('tr', [(_vm.type == 'tote') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.toteid))]) : _vm._e(), _vm._v(" "), (_vm.type == 'bin') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.binid))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.orderid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), (data.consoscan == 1) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.$t('common.completed')))]) : _vm._e(), _vm._v(" "), (data.consoscan == 0) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.$t('common.pending')))]) : _vm._e(), _vm._v(" "), (data.qcstatus) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.qcstatus))]) : _vm._e(), _vm._v(" "), (!data.qcstatus) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.$t('common.pending')))]) : _vm._e()])
  })], 2)]) : _vm._e(), _c('br')])]) : _vm._e()], 1)])], 1)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-004060ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-004060ac","hasScoped":true}!./src/views/components/consopacking/consopacking.component.html
// module id = 1824
// module chunks = 0